<mp-entity-item-slots class="catalog-item" [class.catalog-item--removed]="catalog().isRemoved">
  <mp-entity-item-status [class]="{ green: catalog().lastPublication }" />

  <ng-container ngProjectAs="mp-drag-handle">
    <ng-content select="mp-drag-handle" />
  </ng-container>

  <mp-catalog-type-icon class="catalog-type-icon" [type]="catalog().type" />

  <span class="name truncate">{{ catalog().supplier.name }}</span>
  <span class="meta truncate">{{ catalog().dataSource }}</span>
  <span class="meta truncate">{{ catalog().name }}</span>

  <mp-catalog-covin-badge class="catalog-covin-badge" [value]="catalog().currentCovinRate" [hideLabel]="true" />

  <span class="meta meta--date truncate">
    {{ catalog().lastRelease | humanizeRelativeDate: { whenInRange: { days: 2 } } }}
  </span>

  @if (allowNavigation()) {
    <mp-entity-item-action-button
      entitiy-item-slots-actions
      icon="north_east"
      (actionClick)="emitIndustryCatalogClicked(catalog().catalogId)"
    />
  }

  @if (allowWrite()) {
    <mp-remove-button
      entitiy-item-slots-actions
      [isRemoved]="catalog().isRemoved"
      (clicked)="emitItemRemoved(catalog())"
    />
  }

  @if (catalog().isUpdated) {
    <mp-entity-item-footer>
      <mp-catalog-item-footer
        [catalog]="catalog()"
        [allowWrite]="allowWrite()"
        (itemUpdated)="emitIndustryCatalogUpdate($event)"
      />
    </mp-entity-item-footer>
  }
</mp-entity-item-slots>
